import buttonModal from './buttonModal.vue'
export default buttonModal
